import React from 'react';
import { cn } from '@ideoz/ui';
import { PERM_LABEL, type PermLevel } from '../data/catalog';

interface SegmentedControlProps {
  value: PermLevel;
  levels: PermLevel[];
  onChange: (level: PermLevel) => void;
}

/** Active-state colour per level — reads as increasing access (off → full). */
const LEVEL_ACTIVE: Record<PermLevel, string> = {
  no_access: 'bg-gray-500 text-white dark:bg-gray-600',
  read: 'bg-blue-500 text-white',
  write: 'bg-amber-500 text-white',
  read_write: 'bg-emerald-600 text-white',
};

/** Segmented pill selector for a permission area's access level. */
export const SegmentedControl: React.FC<SegmentedControlProps> = ({ value, levels, onChange }) => (
  <div
    role="radiogroup"
    className="inline-flex flex-shrink-0 rounded-lg bg-gray-100 p-0.5 dark:bg-gray-800"
  >
    {levels.map((level) => {
      const active = level === value;
      return (
        <button
          key={level}
          type="button"
          role="radio"
          aria-checked={active}
          onClick={() => onChange(level)}
          className={cn(
            'rounded-md px-3 py-1.5 text-xs font-medium transition-colors whitespace-nowrap',
            active
              ? cn('shadow-sm', LEVEL_ACTIVE[level])
              : 'text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100'
          )}
        >
          {PERM_LABEL[level]}
        </button>
      );
    })}
  </div>
);

export default SegmentedControl;
